import React from 'react';
import PropTypes from 'prop-types';
import SearchBar from '../SearchBar';

const SearchInput = ({ value, onChange, onKeyPress, onSearchSubmit, placeholder = "Search...", autocomplete, uniqueId = "default" }) => {
  return (
    <SearchBar
      value={value}
      onChange={onChange}
      onKeyPress={onKeyPress}
      onSearchSubmit={onSearchSubmit}
      placeholder={placeholder}
      autocomplete={autocomplete}
      uniqueId={uniqueId}
    />
  );
};

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  onSearchSubmit: PropTypes.func,
  placeholder: PropTypes.string,
  autocomplete: PropTypes.string,
  uniqueId: PropTypes.string
};

export default SearchInput; 